import { render, staticRenderFns } from "./SimpleTable.vue?vue&type=template&id=e2609b54&"
import script from "./SimpleTable.vue?vue&type=script&lang=js&"
export * from "./SimpleTable.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SimpleTable.vue"
export default component.exports